import { R } from './fancybox.esm-Dbi2ItDK.js';

if (!customElements.get('country-popup')) {
  class CountryPopup extends HTMLElement {
    constructor() {
      super();
      this.countryPopupKey = 'country_popup';
      this.specialistId = null;
      this.timer = 1000;
      this.wrapper = this.querySelector('.popup-wrapper');
      this.closeButton = this.querySelector('.country-message-stay-button');
    }

    connectedCallback() {
      // Retrieve and parse any options passed via attributes
      const openInSeconds = this.getAttribute('open-in-s');
      if (openInSeconds) this.timer = openInSeconds * 1000;

      const testMode = this.getAttribute('test-mode');
      if (testMode == 'true') {
        sessionStorage.removeItem(this.countryPopupKey);
      }

      // Check if popup should be displayed
      if (!this.shouldShowPopup()) return;

      // Set timer to display the popup
      setTimeout(() => this.showPopup(), this.timer);

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => R.close());
      }
    }

    shouldShowPopup() {
      // Check if the popup has been shown already
      if (sessionStorage.getItem(this.countryPopupKey)) return false;

      // Check for the 'ref' parameter in sessionStorage or cookies
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('ref')) return false;

      if (this.isLocalStorageEnabled()) {
        this.specialistId = sessionStorage.getItem('ref');
      } else {
        const cookies = Object.fromEntries(
          document.cookie.split('; ').map((v) => v.split(/=(.*)/s))
        );
        this.specialistId = cookies['ref'];
      }

      return !this.specialistId && !urlParams.get('from_country_popup');
    }

    showPopup() {
      this.wrapper.classList.remove('hidden');

      new R([
        {
          src: this.wrapper,
          type: 'html',
        },
      ]);

      sessionStorage.setItem(this.countryPopupKey, true);
    }

    closePopup() {
      R.close();
    }

    isLocalStorageEnabled() {
      try {
        sessionStorage.setItem('test', 'test');
        sessionStorage.removeItem('test');
        return true;
      } catch (e) {
        return false;
      }
    }
  }

  customElements.define('country-popup', CountryPopup);
}
